import type {PermissionLevels, PermissionTreeItem} from '../typedef';

type GetSelectedCodes = (selectedLevel: PermissionLevels, tree: PermissionTreeItem, codes?: string[]) => string[];
export const getSelectedCodes: GetSelectedCodes = (selectedLevel, tree, codes = []) => {
    if (tree.code) {
        return [
            ...tree.level <= selectedLevel ? [tree.code] : [],
            ...tree.children
                ? tree.children.reduce<string[]>((acc, curr) => [
                        ...acc,
                        ...getSelectedCodes(selectedLevel, curr, codes),
                    ], []) : [],
        ];
    } else {
        return codes;
    }
};
